// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__ueFBk","title":"style_title__K6hLZ"};